module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope && !_vm.$route.meta.hideLoader),
      expression: "!$route.meta.isAuthView && !$store.state.user.scope && !$route.meta.hideLoader"
    }],
    staticClass: "medLoader",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "bootLoader",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "static/loader-gif.gif",
      "alt": _vm.$t('message.loadingText')
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.loadingMessage)
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55bc8a1d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BootLoader/BootLoader.vue
// module id = 3180
// module chunks = 1